// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --icon-vk: #07f;
    --icon-vk-hover: #006be5;
    --icon-youtube: red;
    --icon-youtube-hover: #e50000;
    --icon-discord: #5865f2;
    --icon-discord-hover: #4856f0;
    --color-accent: #0af;
    --color-background: white;
    --stroke-width: calc(1em / 16);
    --font-size: 10vmin;
    --font-weight: 700;
    --letter-spacing: calc(1em / 8);
    --max_width_roulete:999px;
    --min_height_roulete:600px;
}`, "",{"version":3,"sources":["webpack://./src/vars_main.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;IACvB,6BAA6B;IAC7B,oBAAoB;IACpB,yBAAyB;IACzB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,yBAAyB;IACzB,0BAA0B;AAC9B","sourcesContent":[":root {\n    --icon-vk: #07f;\n    --icon-vk-hover: #006be5;\n    --icon-youtube: red;\n    --icon-youtube-hover: #e50000;\n    --icon-discord: #5865f2;\n    --icon-discord-hover: #4856f0;\n    --color-accent: #0af;\n    --color-background: white;\n    --stroke-width: calc(1em / 16);\n    --font-size: 10vmin;\n    --font-weight: 700;\n    --letter-spacing: calc(1em / 8);\n    --max_width_roulete:999px;\n    --min_height_roulete:600px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
